// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Main-title {
  display: flex;
  justify-content: space-between;
}

.Main-title-left {
  display: flex;
  width: 50%;
  align-items: center;
  height: 8vh;
  gap: 0.5vw;
}

.Main-title-left span {
  color: var(--main-title);
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 36px;
  margin-right: 1vw;
}

.map-view-options {
  display: flex;
  align-items: center;
  gap: 1vw;
}

.map-view-options label {
  cursor: pointer;
}

.Map-View {
  border-right: 1px solid rgb(232, 223, 213, .5);
  height: 69vh;
  width: 50%;
}

.Map-View-Description>span {
  color: var(--map-filter-description);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.MapCard {
  margin-top: 10px;
  display: flex;
}

.filter-options {
  margin-top: 20px;
  display: flex;
  gap: 20px;
}

.Map-Right {
  width: 50%;
  padding-left: 2%;
}

.year-indicator {
  margin-top: 2vh;
  display: flex;
  align-items: center;
  gap: 1vw;
}

.indicator-container {
  display: flex;
  align-items: center;
  gap: 0.5vw;
}

.indicator-circle {
  height: 2vh;
  width: 2vh;
  border-radius: 100%;
}


.dowload_button button {
  padding: 1.3vh 1vw;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: #E67817;
  border-radius: 8px;
  border-color: transparent;
  font-size: 0.75rem;
  color: #FFFF;
  transition: background-color 0.3s ease, transform 0.3s ease, color 0.3s ease;
}

.map-container {
  width: 100%;
}

.map-setting-view {
  padding: 0vh 1.5vw;
  width: 100%;
  /* overflow-y: auto; */
  margin-top: 1vh;
}

.map-setting-view-container {
  height: 78vh;
  overflow: auto;
}

.map-toggle-btn {
  padding: 1vh 1vw;
  margin: 1vh 1.5vw;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: #E67817;
  border-radius: 8px;
  border-color: transparent;
  font-size: 0.75rem;
  color: #FFFF;
  transition: background-color 0.3s ease, transform 0.3s ease, color 0.3s ease;
}

.Polygon-View {
  border-right: 1px solid rgb(232, 223, 213, .5);
  height: 71vh;
  width: 90%;
  padding-bottom: 1vh;
}

.gender-filter {
  display: flex;
  gap: 1vw;
  margin-top: 2vh;
}

.gender-filter label {
  display: flex;
  gap: 0.2vw;
  cursor: pointer;
}

.single-select-checkbox {
  margin: 2vh 0;
}

.polygon-species-names {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(90px, 1fr));
  gap: 16px;
  width: 26vw;
  padding: 2vh 0;
  gap: 1vw;
  margin-top: 2vh;
  overflow-y: auto;
}

/* TigerOverlap.css */

:root {
  --primary-orange: #E67817;
  --primary-green: #38514C;
  --light-orange: #F4A261;
  --lightest-orange: #FCE0C4;
  --dark-orange: #D2691E;
  --light-green: #38514C;
  --dark-green: #2A3B36;
  --cream: #FDF6E3;
  --light-gray: #F8F9FA;
  --shadow: rgba(56, 81, 76, 0.15);
  --shadow-hover: rgba(56, 81, 76, 0.25);
}

.tiger-overlap-wrapper {
  margin: 2vh 0;
  border-radius: 16px;
  box-shadow: 0 4px 16px var(--shadow);
  overflow: hidden;
}

.tiger-overlap-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
  padding: 1rem;
  position: relative;
  overflow: hidden;
}

.main-title {
  font-size: 1.2rem;
  position: relative;
  z-index: 1;
}

.table-headers {
  display: flex;
  background: var(--dark-orange);
  position: sticky;
  top: 0;
  z-index: 10;
}

.header-main-tiger {
  width: 15vw;
  padding: 1rem 1.5rem;
  font-size: 1rem;
  font-weight: 600;
  color: var(--cream);
  border-right: 2px solid rgba(255, 255, 255, 0.3);
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.1);
}

.header-overlaps {
  flex: 1 1;
  padding: 1rem 1.5rem;
  font-weight: 600;
  font-size: 1rem;
  color: var(--cream);
  display: flex;
  align-items: center;
}

.tiger-overlap-container {
  height: 60vh;
  overflow-y: auto;
  overflow-x: hidden;
}

.tiger-row {
  display: flex;
  border-bottom: 2px solid #E9ECEF;
  background: white;
  transition: all 0.3s ease;
  position: relative;
}

.tiger-row:nth-child(even) {
  background: #FAFBFC;
}

.tiger-header {
  width: 15vw;
  padding: 1.5rem;
  position: sticky;
  left: 0;
  background: var(--cream);
  z-index: 5;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.tiger-name {
  font-size: 1.2rem;
  color: var(--dark-orange);
  margin-bottom: 0.5rem;
}

.overlap-count {
  font-size: 1rem;
  color: var(--primary-orange);
  font-weight: 500;
  display: inline-block;
}

.overlaps-container {
  display: flex;
  max-width: 64vw;
  overflow-x: auto;
  flex-wrap: nowrap;
  gap: 1.5rem;
  padding: 1.5rem;
  flex: 1 1;
  align-items: center;
}

@media screen and (min-width: 1600px) {
  .overlaps-container {
    max-width: 64vw; 
  }
}

.overlap-item {
  flex-shrink: 0;
  padding: 1rem 1.5rem;
  background: linear-gradient(135deg, white 0%, var(--cream) 100%);
  border: 2px solid rgba(56, 81, 76, 0.1);
  border-radius: 12px;
  min-width: 100px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.overlap-tiger {
  font-size: 0.8rem;
  margin-bottom: 0.75rem;
  position: relative;
  z-index: 1;
}

.overlap-details {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  position: relative;
  z-index: 1;
}

.area {
  font-size: 0.8rem;
  background: rgba(56, 81, 76, 0.1);
  padding: 0.3rem 0.8rem;
  border-radius: 8px;
  text-align: center;
}

.percentage {
  font-size: 0.8rem;
  color: white;
  text-align: center;
  padding: 0.5rem;
  border-radius: 8px;
}

.percentage.red {
  background-color: #FF0000;
}

.percentage.yellow {
  color: var(--dark-green);
  background-color: #FFFF00;
}

.percentage.green {
  background-color: #91C70D;
}

/* Enhanced Scrollbar Styling */
.tiger-overlap-container::-webkit-scrollbar,
.overlaps-container::-webkit-scrollbar {
  height: 12px;
  width: 12px;
  cursor: pointer;
}

.tiger-overlap-container::-webkit-scrollbar-track,
.overlaps-container::-webkit-scrollbar-track {
  background: var(--light-gray);
  border-radius: 6px;
  border: 1px solid #E9ECEF;
}

.tiger-overlap-container::-webkit-scrollbar-thumb,
.overlaps-container::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, var(--primary-orange) 0%, var(--dark-orange) 100%);
  border-radius: 6px;
  border: 2px solid var(--light-gray);
}


.tiger-overlap-container::-webkit-scrollbar-corner {
  background: var(--light-gray);
}

/* Responsive Design */
@media (max-width: 1024px) {
  .main-title {
    font-size: 2rem;
  }

  .tiger-header,
  .header-main-tiger {
    width: 25vw;
    min-width: 200px;
  }

  .overlap-item {
    min-width: 180px;
  }
}

@media (max-width: 768px) {
  .tiger-overlap-wrapper {
    width: 98vw;
    border-radius: 12px;
  }

  .tiger-overlap-header {
    padding: 1.5rem;
  }

  .main-title {
    font-size: 1.8rem;
  }

  .subtitle {
    font-size: 1rem;
  }

  .tiger-header,
  .header-main-tiger {
    width: 30vw;
    min-width: 160px;
    padding: 1rem;
  }

  .tiger-name {
    font-size: 1.1rem;
  }

  .overlap-item {
    min-width: 150px;
    padding: 0.8rem 1rem;
  }

  .overlaps-container {
    padding: 1rem;
    gap: 1rem;
  }
}

@media (max-width: 480px) {
  .tiger-overlap-header {
    padding: 1rem;
  }

  .main-title {
    font-size: 1.5rem;
  }

  .subtitle {
    font-size: 0.9rem;
  }

  .tiger-header,
  .header-main-tiger {
    width: 35vw;
    min-width: 140px;
    padding: 0.8rem;
  }

  .tiger-name {
    font-size: 1rem;
  }

  .overlap-count {
    font-size: 0.8rem;
  }

  .overlap-item {
    min-width: 130px;
    padding: 0.6rem 0.8rem;
  }

  .overlap-tiger {
    font-size: 0.7rem;
  }

  .area,
  .percentage {
    font-size: 0.9rem;
  }
}


.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
  background: #f8f9fa;
  border-radius: 8px;
}

.loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  color: #6b7280;
}

.loading-spinner {
  animation: spin 1s linear infinite;
  color: #3b82f6;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}



.gender-selector {
  display: flex;
  align-items: center;
}

.radio-group {
  display: flex;
  gap: 20px;
  background: #f3f4f6;
  padding: 8px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}

.radio-option {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 6px 12px;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.radio-option:hover {
  background: #e5e7eb;
}

.radio-option input[type="radio"] {
  margin: 0;
  cursor: pointer;
}

.radio-option input[type="radio"]:checked+.radio-label {
  color: var(--dark-orange);
  font-weight: 600;
}

.radio-label {
  font-size: 14px;
  color: #4b5563;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}


.empty-data-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
  background: #f9fafb;
}

.empty-data-content {
  text-align: center;
  color: #6b7280;
  max-width: 400px;
}

.empty-icon {
  margin: 0 auto 16px;
  opacity: 0.5;
}

.empty-data-content h3 {
  margin: 0 0 8px 0;
  color: #374151;
  font-size: 1.25rem;
  font-weight: 600;
}

.empty-data-content p {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
}

.overlap-tiger-export-button {
  background-color: var(--dark-orange);
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s ease;
}

.overlap-tiger-export-button:hover {
  background-color: var(--light-orange);

}`, "",{"version":3,"sources":["webpack://./src/CSS/Map.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,UAAU;EACV,mBAAmB;EACnB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,8CAA8C;EAC9C,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,UAAU;EACV,mBAAmB;AACrB;;;AAGA;EACE,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,4EAA4E;AAC9E;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,4EAA4E;AAC9E;;AAEA;EACE,8CAA8C;EAC9C,YAAY;EACZ,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,WAAW;EACX,cAAc;EACd,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA,qBAAqB;;AAErB;EACE,yBAAyB;EACzB,wBAAwB;EACxB,uBAAuB;EACvB,0BAA0B;EAC1B,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,qBAAqB;EACrB,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gDAAgD;EAChD,aAAa;EACb,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,SAAO;EACP,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,OAAO;EACP,wBAAwB;EACxB,UAAU;EACV,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,SAAO;EACP,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,gEAAgE;EAChE,uCAAuC;EACvC,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;EACjC,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,+BAA+B;AAC/B;;EAEE,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,6BAA6B;EAC7B,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;EAEE,sFAAsF;EACtF,kBAAkB;EAClB,mCAAmC;AACrC;;;AAGA;EACE,6BAA6B;AAC/B;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;;IAEE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,WAAW;IACX,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,SAAS;EACX;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,WAAW;IACX,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,iBAAiB;EACnB;AACF;;;AAGA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;;;AAIA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;;AAGA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;;AAEvC","sourcesContent":[".Main-title {\n  display: flex;\n  justify-content: space-between;\n}\n\n.Main-title-left {\n  display: flex;\n  width: 50%;\n  align-items: center;\n  height: 8vh;\n  gap: 0.5vw;\n}\n\n.Main-title-left span {\n  color: var(--main-title);\n  font-family: Inter;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 36px;\n  margin-right: 1vw;\n}\n\n.map-view-options {\n  display: flex;\n  align-items: center;\n  gap: 1vw;\n}\n\n.map-view-options label {\n  cursor: pointer;\n}\n\n.Map-View {\n  border-right: 1px solid rgb(232, 223, 213, .5);\n  height: 69vh;\n  width: 50%;\n}\n\n.Map-View-Description>span {\n  color: var(--map-filter-description);\n  font-family: Inter;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n}\n\n.MapCard {\n  margin-top: 10px;\n  display: flex;\n}\n\n.filter-options {\n  margin-top: 20px;\n  display: flex;\n  gap: 20px;\n}\n\n.Map-Right {\n  width: 50%;\n  padding-left: 2%;\n}\n\n.year-indicator {\n  margin-top: 2vh;\n  display: flex;\n  align-items: center;\n  gap: 1vw;\n}\n\n.indicator-container {\n  display: flex;\n  align-items: center;\n  gap: 0.5vw;\n}\n\n.indicator-circle {\n  height: 2vh;\n  width: 2vh;\n  border-radius: 100%;\n}\n\n\n.dowload_button button {\n  padding: 1.3vh 1vw;\n  cursor: pointer;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  background-color: #E67817;\n  border-radius: 8px;\n  border-color: transparent;\n  font-size: 0.75rem;\n  color: #FFFF;\n  transition: background-color 0.3s ease, transform 0.3s ease, color 0.3s ease;\n}\n\n.map-container {\n  width: 100%;\n}\n\n.map-setting-view {\n  padding: 0vh 1.5vw;\n  width: 100%;\n  /* overflow-y: auto; */\n  margin-top: 1vh;\n}\n\n.map-setting-view-container {\n  height: 78vh;\n  overflow: auto;\n}\n\n.map-toggle-btn {\n  padding: 1vh 1vw;\n  margin: 1vh 1.5vw;\n  cursor: pointer;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  background-color: #E67817;\n  border-radius: 8px;\n  border-color: transparent;\n  font-size: 0.75rem;\n  color: #FFFF;\n  transition: background-color 0.3s ease, transform 0.3s ease, color 0.3s ease;\n}\n\n.Polygon-View {\n  border-right: 1px solid rgb(232, 223, 213, .5);\n  height: 71vh;\n  width: 90%;\n  padding-bottom: 1vh;\n}\n\n.gender-filter {\n  display: flex;\n  gap: 1vw;\n  margin-top: 2vh;\n}\n\n.gender-filter label {\n  display: flex;\n  gap: 0.2vw;\n  cursor: pointer;\n}\n\n.single-select-checkbox {\n  margin: 2vh 0;\n}\n\n.polygon-species-names {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(90px, 1fr));\n  gap: 16px;\n  width: 26vw;\n  padding: 2vh 0;\n  gap: 1vw;\n  margin-top: 2vh;\n  overflow-y: auto;\n}\n\n/* TigerOverlap.css */\n\n:root {\n  --primary-orange: #E67817;\n  --primary-green: #38514C;\n  --light-orange: #F4A261;\n  --lightest-orange: #FCE0C4;\n  --dark-orange: #D2691E;\n  --light-green: #38514C;\n  --dark-green: #2A3B36;\n  --cream: #FDF6E3;\n  --light-gray: #F8F9FA;\n  --shadow: rgba(56, 81, 76, 0.15);\n  --shadow-hover: rgba(56, 81, 76, 0.25);\n}\n\n.tiger-overlap-wrapper {\n  margin: 2vh 0;\n  border-radius: 16px;\n  box-shadow: 0 4px 16px var(--shadow);\n  overflow: hidden;\n}\n\n.tiger-overlap-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  color: white;\n  padding: 1rem;\n  position: relative;\n  overflow: hidden;\n}\n\n.main-title {\n  font-size: 1.2rem;\n  position: relative;\n  z-index: 1;\n}\n\n.table-headers {\n  display: flex;\n  background: var(--dark-orange);\n  position: sticky;\n  top: 0;\n  z-index: 10;\n}\n\n.header-main-tiger {\n  width: 15vw;\n  padding: 1rem 1.5rem;\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--cream);\n  border-right: 2px solid rgba(255, 255, 255, 0.3);\n  display: flex;\n  align-items: center;\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.header-overlaps {\n  flex: 1;\n  padding: 1rem 1.5rem;\n  font-weight: 600;\n  font-size: 1rem;\n  color: var(--cream);\n  display: flex;\n  align-items: center;\n}\n\n.tiger-overlap-container {\n  height: 60vh;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.tiger-row {\n  display: flex;\n  border-bottom: 2px solid #E9ECEF;\n  background: white;\n  transition: all 0.3s ease;\n  position: relative;\n}\n\n.tiger-row:nth-child(even) {\n  background: #FAFBFC;\n}\n\n.tiger-header {\n  width: 15vw;\n  padding: 1.5rem;\n  position: sticky;\n  left: 0;\n  background: var(--cream);\n  z-index: 5;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.tiger-name {\n  font-size: 1.2rem;\n  color: var(--dark-orange);\n  margin-bottom: 0.5rem;\n}\n\n.overlap-count {\n  font-size: 1rem;\n  color: var(--primary-orange);\n  font-weight: 500;\n  display: inline-block;\n}\n\n.overlaps-container {\n  display: flex;\n  max-width: 64vw;\n  overflow-x: auto;\n  flex-wrap: nowrap;\n  gap: 1.5rem;\n  padding: 1.5rem;\n  flex: 1;\n  align-items: center;\n}\n\n@media screen and (min-width: 1600px) {\n  .overlaps-container {\n    max-width: 64vw; \n  }\n}\n\n.overlap-item {\n  flex-shrink: 0;\n  padding: 1rem 1.5rem;\n  background: linear-gradient(135deg, white 0%, var(--cream) 100%);\n  border: 2px solid rgba(56, 81, 76, 0.1);\n  border-radius: 12px;\n  min-width: 100px;\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.overlap-tiger {\n  font-size: 0.8rem;\n  margin-bottom: 0.75rem;\n  position: relative;\n  z-index: 1;\n}\n\n.overlap-details {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  position: relative;\n  z-index: 1;\n}\n\n.area {\n  font-size: 0.8rem;\n  background: rgba(56, 81, 76, 0.1);\n  padding: 0.3rem 0.8rem;\n  border-radius: 8px;\n  text-align: center;\n}\n\n.percentage {\n  font-size: 0.8rem;\n  color: white;\n  text-align: center;\n  padding: 0.5rem;\n  border-radius: 8px;\n}\n\n.percentage.red {\n  background-color: #FF0000;\n}\n\n.percentage.yellow {\n  color: var(--dark-green);\n  background-color: #FFFF00;\n}\n\n.percentage.green {\n  background-color: #91C70D;\n}\n\n/* Enhanced Scrollbar Styling */\n.tiger-overlap-container::-webkit-scrollbar,\n.overlaps-container::-webkit-scrollbar {\n  height: 12px;\n  width: 12px;\n  cursor: pointer;\n}\n\n.tiger-overlap-container::-webkit-scrollbar-track,\n.overlaps-container::-webkit-scrollbar-track {\n  background: var(--light-gray);\n  border-radius: 6px;\n  border: 1px solid #E9ECEF;\n}\n\n.tiger-overlap-container::-webkit-scrollbar-thumb,\n.overlaps-container::-webkit-scrollbar-thumb {\n  background: linear-gradient(135deg, var(--primary-orange) 0%, var(--dark-orange) 100%);\n  border-radius: 6px;\n  border: 2px solid var(--light-gray);\n}\n\n\n.tiger-overlap-container::-webkit-scrollbar-corner {\n  background: var(--light-gray);\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .main-title {\n    font-size: 2rem;\n  }\n\n  .tiger-header,\n  .header-main-tiger {\n    width: 25vw;\n    min-width: 200px;\n  }\n\n  .overlap-item {\n    min-width: 180px;\n  }\n}\n\n@media (max-width: 768px) {\n  .tiger-overlap-wrapper {\n    width: 98vw;\n    border-radius: 12px;\n  }\n\n  .tiger-overlap-header {\n    padding: 1.5rem;\n  }\n\n  .main-title {\n    font-size: 1.8rem;\n  }\n\n  .subtitle {\n    font-size: 1rem;\n  }\n\n  .tiger-header,\n  .header-main-tiger {\n    width: 30vw;\n    min-width: 160px;\n    padding: 1rem;\n  }\n\n  .tiger-name {\n    font-size: 1.1rem;\n  }\n\n  .overlap-item {\n    min-width: 150px;\n    padding: 0.8rem 1rem;\n  }\n\n  .overlaps-container {\n    padding: 1rem;\n    gap: 1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .tiger-overlap-header {\n    padding: 1rem;\n  }\n\n  .main-title {\n    font-size: 1.5rem;\n  }\n\n  .subtitle {\n    font-size: 0.9rem;\n  }\n\n  .tiger-header,\n  .header-main-tiger {\n    width: 35vw;\n    min-width: 140px;\n    padding: 0.8rem;\n  }\n\n  .tiger-name {\n    font-size: 1rem;\n  }\n\n  .overlap-count {\n    font-size: 0.8rem;\n  }\n\n  .overlap-item {\n    min-width: 130px;\n    padding: 0.6rem 0.8rem;\n  }\n\n  .overlap-tiger {\n    font-size: 0.7rem;\n  }\n\n  .area,\n  .percentage {\n    font-size: 0.9rem;\n  }\n}\n\n\n.loading-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 300px;\n  background: #f8f9fa;\n  border-radius: 8px;\n}\n\n.loading-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  color: #6b7280;\n}\n\n.loading-spinner {\n  animation: spin 1s linear infinite;\n  color: #3b82f6;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n\n\n.gender-selector {\n  display: flex;\n  align-items: center;\n}\n\n.radio-group {\n  display: flex;\n  gap: 20px;\n  background: #f3f4f6;\n  padding: 8px;\n  border-radius: 8px;\n  border: 1px solid #e5e7eb;\n}\n\n.radio-option {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  padding: 6px 12px;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n}\n\n.radio-option:hover {\n  background: #e5e7eb;\n}\n\n.radio-option input[type=\"radio\"] {\n  margin: 0;\n  cursor: pointer;\n}\n\n.radio-option input[type=\"radio\"]:checked+.radio-label {\n  color: var(--dark-orange);\n  font-weight: 600;\n}\n\n.radio-label {\n  font-size: 14px;\n  color: #4b5563;\n  cursor: pointer;\n  user-select: none;\n}\n\n\n.empty-data-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 400px;\n  background: #f9fafb;\n}\n\n.empty-data-content {\n  text-align: center;\n  color: #6b7280;\n  max-width: 400px;\n}\n\n.empty-icon {\n  margin: 0 auto 16px;\n  opacity: 0.5;\n}\n\n.empty-data-content h3 {\n  margin: 0 0 8px 0;\n  color: #374151;\n  font-size: 1.25rem;\n  font-weight: 600;\n}\n\n.empty-data-content p {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.overlap-tiger-export-button {\n  background-color: var(--dark-orange);\n  color: white;\n  border: none;\n  padding: 6px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: background-color 0.2s ease;\n}\n\n.overlap-tiger-export-button:hover {\n  background-color: var(--light-orange);\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
